// Utility to build query params, omitting undefined/null/empty string values
export function buildQueryParams(obj) {
  const params = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params[key] = value;
    }
  });
  return params;
} 